import { Stream } from "@cloudflare/stream-react";

export type CloudflareVideoProps = {
  id: string;
};

export const CloudflareVideo = ({ id }: CloudflareVideoProps) => {
  return <Stream className="cloudflare-video" src={id} controls />;
};
